module.exports = __webpack_public_path__ + "static/media/icono_sicom.69b334e0.svg";